// Copyright 2025, University of Maryland, All Rights Reserved
import { useAuth } from '@umd-dit-ai-workspace/workspaces-component';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@umd-dit-ai-workspace/shared-ui';
import { TemplatesConfigurationView } from './TemplatesConfigurationView';
import { PromptsConfigurationView } from './PromptsConfigurationView';
import { WorkspaceRequiredGuard } from './WorkspaceRequiredGuard';
import { LLMConfigurationView } from './LLMConfigurationView';

export function WorkspaceConfigurationView() {
  const { selectedOrganizationId, selectedWorkspaceId } = useAuth();

  return (
    <WorkspaceRequiredGuard
      selectedOrganizationId={selectedOrganizationId}
      selectedWorkspaceId={selectedWorkspaceId}
    >
      <div className="space-y-6">
        {/* LLM Configuration Section */}
        <LLMConfigurationView />

        {/* Templates and Prompts Configuration */}
        <Tabs defaultValue="templates">
          <TabsList className="mb-6">
            <TabsTrigger value="templates">📋 Templates</TabsTrigger>
            <TabsTrigger value="prompts">💬 Prompts</TabsTrigger>
          </TabsList>

          <TabsContent value="templates">
            <TemplatesConfigurationView level="workspace" />
          </TabsContent>

          <TabsContent value="prompts">
            <PromptsConfigurationView level="workspace" />
          </TabsContent>
        </Tabs>
      </div>
    </WorkspaceRequiredGuard>
  );
}
